// Task 24845 - "why does this icon keep appearing for new ones". A quick-link
// shortcut with a link but no uploaded image used to fall back to a generic
// chain icon (fa-solid fa-link), so most shortcuts showed the same anonymous
// icon. Derive the site's favicon from its link so a real icon shows without
// anyone having to upload one. Returns "" when there is no usable URL, so the
// caller can still fall back to the chain icon as a last resort.
export const faviconFromUrl = (rawUrl) => {
  if (!rawUrl) return "";
  try {
    const u = new URL(
      /^https?:\/\//i.test(rawUrl) ? rawUrl : `https://${rawUrl}`
    );
    return `https://www.google.com/s2/favicons?domain=${u.hostname}&sz=64`;
  } catch (e) {
    return "";
  }
};

export default faviconFromUrl;
